// extracted by mini-css-extract-plugin
export default {"collapsibleMenuContainerClass":"FooterMenu_collapsibleMenuContainerClass--Pap"};